// SafeImage.jsx
import React from "react";
import defultLogo from "../../assets/images/lankalearners.png";

export default function SafeImage({
  src,
  alt = "logo",
  className,
  cacheName = "img-cache-v1",
}) {
  const [displaySrc, setDisplaySrc] = React.useState(defultLogo);
  const triedRef = React.useRef(false);

  React.useEffect(() => {
    let cancelled = false;
    let objUrlToRevoke = null;

    async function load() {
      if (!src || !src.trim()) return; 

      try {
        const cache = await caches.open(cacheName);
        const cached = await cache.match(src);
        if (cached) {
          const blob = await cached.blob();
          const obj = URL.createObjectURL(blob);
          objUrlToRevoke = obj;
          if (!cancelled) setDisplaySrc(obj); 
        }
 
        if (!triedRef.current) {
          triedRef.current = true;
          const resp = await fetch(src, { cache: "no-cache" });
          if (resp.ok) {
            await cache.put(src, resp.clone());
            const blob2 = await resp.blob();
            const obj2 = URL.createObjectURL(blob2);
            if (!cancelled) setDisplaySrc(obj2);
            if (objUrlToRevoke) URL.revokeObjectURL(objUrlToRevoke);
            objUrlToRevoke = obj2;
          } else {
            // quota/403/404 → stay on default or cached version
          }
        }
      } catch {
      }
    }

    load();
    return () => {
      cancelled = true;
      if (objUrlToRevoke) URL.revokeObjectURL(objUrlToRevoke);
    };
  }, [src, cacheName]);

  return (
    <img
      src={displaySrc}
      alt={alt}
      className={className}
      loading="lazy"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = defultLogo;
      }}
    />
  );
}
